import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface LocationKeysParams {
  name?: string
  filters?: {
    prices?: {
      minimum?: number
      maximum?: number
    }
  }
}

export interface LocationFilterParams {
  title?: string
  link?: string
  keys?: {
    name?: string
    petAllowed?: boolean
    filters?: {
      petAllowed?: boolean
      childAllowed?: boolean
      suitableChild?: boolean
      numberOfGuest?: number
    }
  }
}

export interface PropertyLocationParams {
  title?: string
  subTitle?: string
  image?: string
  filters?: LocationFilterParams[]
  link?: string
  keys?: LocationKeysParams[]
  locationSearch?: string
  locationName?: string
}

export interface PropertySectionParams {
  image?: string
  title?: string
}

export interface GetPropertiesKeysV2RequestParams {
  locations?: PropertyLocationParams[]
  minPrice?: number
  maxPrice?: number
  image?: string
  section?: PropertySectionParams[]
}

export type PropertyTypeConfigV2 = {
  typeId: number | string
  typeCode: string
  typeDescription: string
  link: string
  linkTitle: string
  titleColor?: string
  isSaveClass?: boolean
  hideOn?: "none" | "web" | "all" | "mobile"
  showEvenRows?: boolean
  keys?: GetPropertiesKeysV2RequestParams
}

export interface GetPropertyConfigsV2APIResponseData extends ResponseData {
  data: PropertyTypeConfigV2[]
}

export interface GetPropertyConfigsV2APIResponse extends AxiosResponse {
  data: GetPropertyConfigsV2APIResponseData
}

export function getPropertyConfigsV2API(
  axiosInstance: AxiosInstance,
): Promise<GetPropertyConfigsV2APIResponse> {
  return axiosInstance({
    data: { avoidClientSideAuth: true },
    method: "get",
    url: "/home/property-config-type/v2",
  }) as Promise<GetPropertyConfigsV2APIResponse>
}
